<template>
  <div class="vote">
    <h3><a :href="vote.href" target="_blank">{{ vote.title }}</a></h3>
    <table class="vote-table">
      <thead>
        <tr>
          <th class="vote-attribution">Party</th>
          <th class="vote-yea">Yea</th>
          <th class="vote-nay">Nay</th>
        </tr>
      </thead>
      <tbody>
        <tr class="vote-dem">
          <td class="vote-attribution"><i class="party-icon fa-solid fa-democrat"></i><span class="vote-attribution-name">Democrats</span></td>
          <td class="vote-yea"><span class="vote-count">{{ vote.votes.demPro }}</span><div class="vote-bar-container"><div :title="barTitle" :style="{ width: voteBarWidth(vote.votes.demPro) }" class="vote-bar"></div></div></td>
          <td class="vote-nay"><span class="vote-count">{{ vote.votes.demCon }}</span><div class="vote-bar-container"><div :title="barTitle" :style="{ width: voteBarWidth(vote.votes.demCon) }" class="vote-bar"></div></div></td>
        </tr>
        <tr class="vote-rep">
          <td class="vote-attribution"><i class="party-icon fa-solid fa-republican"></i><span class="vote-attribution-name">Republicans</span></td>
          <td class="vote-yea"><span class="vote-count">{{ vote.votes.repPro }}</span><div class="vote-bar-container"><div :title="barTitle" :style="{ width: voteBarWidth(vote.votes.repPro) }" class="vote-bar"></div></div></td>
          <td class="vote-nay"><span class="vote-count">{{ vote.votes.repCon }}</span><div class="vote-bar-container"><div :title="barTitle" :style="{ width: voteBarWidth(vote.votes.repCon) }" class="vote-bar"></div></div></td>
        </tr>
      </tbody>
    </table>
    <div class="vote-more-less">
      <a href="" @click.prevent="handleShowMoreInfo">{{ (showMoreInfo) ? 'less' : 'more' }}</a>
    </div>
    <div class="more-info" v-show="showMoreInfo">
      <p class="vote-meta"><em>Bill: {{ vote.bill }}, Congress: {{ vote.congress }}, Date: {{ vote.date }}</em></p>
      <p class="vote-desc">{{ vote.desc }}</p>
      <p v-if="vote.backgroundLinks.length"><strong>reading:</strong> </span><a class="background-link" v-for="link in vote.backgroundLinks" :href="link.href" target="_blank">{{ link.title }}</a></p>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @mixin vote-bar {
    height: 1rem;
    display: inline-block;
  }

  $more-info-size: 14px;
  $dem-blue: #00BEF6;
  $rep-red: #E72100;

  .vote {
    text-align: left;
    background-color: #F7F8FB;
    border: 1px solid grey;
    border-radius: 16px;
    margin-bottom: 24px;
    padding: 16px;
    box-shadow: 0px 2px 3px grey;

    h3 {
      font-family: 'Averia Libre', Avenir, Serif;
      font-size: 20px;
      text-align: center;
      margin: 0;
      padding-bottom: 12px;

      a,
      a:visited,
      a:hover,
      a:active {
        color: inherit;
        text-decoration: none;
      }
    }

    .vote-table {
      margin-left: 1rem;
      width: calc(100% - 1rem);

      .vote-attribution {
        width: 122px;

        i {
          padding-right: 8px;
          opacity: 0.5;
        }
      }

      th, td {
        padding: 2px;
        width: calc(50% - 122px);
      }

      th.vote-yea,
      th.vote-nay {
        padding-left: calc(3rem + 2px);
      }

      .vote-bar-container {
        display: inline-block;
        width: calc(100% - 3rem);
      }

      .vote-count {
        display: inline-block;
        min-width: 3rem;
        text-align: right;
        padding-right: 4px;
        position: relative;
        bottom: 2px;
      }

      .vote-dem {
        .vote-bar {
          @include vote-bar;
          background-color: $dem-blue;
        }
      }

      .vote-rep {
        .vote-bar {
          @include vote-bar;
          background-color: $rep-red;
        }
      }
    }

    .vote-more-less {
      text-align: right;
      font-size: $more-info-size;
    }

    .more-info {
      border-top: 1px solid grey;
      margin-top: 0.5rem;

      a.background-link {
        font-size: $more-info-size;
        display: inline-block;
        margin-right: 8px;
      }

      p {
        font-size: $more-info-size;
        margin: 6px 0;
      }

      p.vote-desc {
        font-size: inherit;
        margin: 6px 0;
      }

      p.vote-meta {
      }
    }
  }

  @media (min-width: 320px) and (max-width: 768px) {
    .vote-table {
      th, td {
        width: calc(50% - 2rem) !important;
      }

      .vote-attribution {
        width: 2rem !important;

        .vote-attribution-name {
          display: none;
        }

        i {
          &.fa-democrat {
            color: $dem-blue;
          }

          &.fa-republican {
            color: $rep-red;
          }
        }
      }
    }
  }

</style>

<script>
export default {
  name: 'Vote',

  props:['vote'],

  data: () => ({
    showMoreInfo: false,
    voteBarMaxWidth: 142,
    barTitle: "bar shows % of total votes"
  }),

  methods: {

    handleShowMoreInfo() {
      this.showMoreInfo = !this.showMoreInfo
    },

    voteBarWidth(voteCount) {
      let votePerc = this.votesMax / voteCount
      let widthPerc = Math.round ( this.voteBarMaxWidth / votePerc )
      return widthPerc + '%'
    }

  },

  watch: {

  },

  computed: {

    votesMax() {
      return this.vote.votes.demPro + this.vote.votes.demCon + this.vote.votes.repPro + this.vote.votes.repCon
    }

  },

  created() {

  },

  mounted() {

  }
}
</script>